import { TipoSoggettoAnagrafeEnum } from "@app/shared/enum/tipo-soggetto-anagrafe-enum";
import { DettaglioSoggettoAnagrafeDTO } from "./dettaglio-soggetto-anagrafeDTO";
import { RecapitoAnagrafeDTO } from "./recapito-anagrafeDTO";

export class SoggettoRicercaDTO {
  tipo: TipoSoggettoAnagrafeEnum;
  denominazione: string;
  nome: string;
  cognome: string;
  codiceFiscale: string;
  sistemaProvenienza: string;
}
